import Section from '../components/section';
import { Grid, Stack, Typography, styled } from '@mui/material';
import ShowerIcon from '@mui/icons-material/Shower';
import PropaneIcon from '@mui/icons-material/Propane';
import HeatPumpIcon from '@mui/icons-material/HeatPump';

import IconCard from '../components/iconCard';

const Services = () => {
  return (
    <Section id='services'>
      <Stack spacing={4}>
        <Title variant='h3'>Services</Title>
        <Typography variant='subtitle1'>
          Focused on the following services:
        </Typography>
        <Grid
          container
          spacing={4}
          justifyContent='center'
          style={{ marginLeft: '-32px' }}
        >
          <Grid item xs={12} lg={4} style={{ maxWidth: '500px' }}>
            <IconCard
              icon={<ShowerIcon />}
              title='Design'
              subtitle='Clean, user-friendly interfaces built with attention to detail. Every layout is crafted to balance aesthetics and functionality, creating a smooth and engaging user experience.'
            />
          </Grid>
          <Grid item xs={12} lg={4} style={{ maxWidth: '500px' }}>
            <IconCard
              icon={<PropaneIcon />}
              title='Development'
              subtitle='Tailored solutions built from the ground up — scalable, maintainable, and ready to grow with any project. Every line of code is written with performance and clarity in mind.'
            />
          </Grid>
          <Grid item xs={12} lg={4} style={{ maxWidth: '500px' }}>
            <IconCard
              icon={<HeatPumpIcon />}
              title='Testing'
              subtitle='From automated tests to manual QA, every step is designed to catch bugs early and ensure a smooth, stable user experience.'
            />
          </Grid>
        </Grid>
      </Stack>
    </Section>
  );
};

export default Services;

const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 600,
}));
